
import axios from '../../helpers/axios';


export const updatedProductMaterial = (id, updateProductMaterial) => axios.patch(`/productMaterial/update/${id}`, updateProductMaterial)
